import React from 'react';
import BookingModal from '../components/BookingModal';

const BookNow = () => (
  <BookingModal open onClose={() => {}} />
)

export default BookNow;
